<template>
    <span :class="{
        'uik-tab__item': true,
        'active': active
    }">
        <slot></slot>
        <span v-if="extra != ''" class="uik-tab__extra">
            {{ extra }}
        </span>
    </span>
</template>

<script>
export default {
    name: "UikTabItem",
    props: {
        extra: { type: String, default: "" },
        active: { type: Boolean, default: false }
    }
}
</script>

<style lang="scss">
.uik-tab__item {
  height: 70px;
  @media #{$mediaMobile} {
    height: 56px;
  }
  border-bottom: 3px solid transparent;
  margin: 0 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: $textBase;
  .uik-tab__extra {
    color: $textSecondary;
    font-weight: 400;
    display: inline-block;
    margin-left: 5px;
    font-size: .875rem;
  }
  &:hover {
    color: $textMain;
    border-bottom-color: rgba($primary, .3);
  }
  &:global(.active) {
    border-bottom-color: $primary;
    font-weight: 500;
    color: $textMain;
  }
  &.uik-tab__small,
  &.uik-tab__smaller {
    height: 62px;
    font-size: .875rem;
    .uik-tab__extra {
      font-size: .75rem;
    }
  }
  &.uik-tab__smaller {
    height: 50px;
  }
}
</style>
